if (window.opener && (window.name === 'studio-auth')
    && window.location.host === window.opener.location.host) {
    window.opener.postMessage(window.location.href, window.opener.origin);
    window.close();
}
